module.exports = __webpack_public_path__ + "media/images/prof-c136f47acc1b15f12fe768b8988b329a.png";